/**
 * Resolves whether orders are required for a practice from its integrationConfig.
 *
 * Handles two config shapes:
 *   - v1: { ordersRequired: true }
 *   - v2: { orders: { required: true, type: '...' } }
 */
export default function resolveOrdersRequired(integrationConfig) {
  if (!integrationConfig) return false
  const { orders, ordersRequired } = integrationConfig
  if (orders && typeof orders === 'object') return !!orders.required
  return !!ordersRequired
}
